import { formatCurrency as formatCurrencyCommon } from "common/utils/format/number";

export function formatCurrency(amount: number | string, currency: string = "$"): string {
  if (amount === undefined || amount === null) {
    amount = 0.0;
  }

  return formatCurrencyCommon(amount, currency);
}
